import { Controller } from './Controller';
import { registerPwa } from './Pwa';
Controller.run();
registerPwa();
console.log('Version: 1.0.1');
